import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { RouteError } from "@/shared/components/RouteError";
import { hasPermission } from "@/shared/utils/permissions";

// Layer 1 of the triple-derived gate (BEL-467): the nav entry
// (`shared/config/navigation.ts`) and the list's action buttons
// (`features/stations/components/StationList.tsx`) re-derive this independently,
// so a direct URL never leaks a screen the nav hides.
export const Route = createFileRoute("/app/admin/stations")({
  beforeLoad: ({ context }) => {
    if (!hasPermission(context.auth.user, "admin.stations.read")) {
      throw redirect({ to: "/app" });
    }
  },
  errorComponent: ({ error }) => <RouteError error={error} />,
  component: () => <Outlet />,
});
